import React, { useRef } from 'react'
import MwRichEditor from './MwRichEditor'

const MwTextArea = ({id,value,onChange,label,placeholder,rows,minHeight,invalid,invalidMsg,classNameCustom='',enableToolbar=false,rich=false,dir='auto',textAlign}) => {
    const textareaRef = useRef(null);
    const resolvedValue = value == null ? '' : String(value);
    const triggerChange = (nextValue, selectionStart, selectionEnd) => {
        onChange?.({ target: { name: id, value: nextValue } });
        if (selectionStart == null || selectionEnd == null) return;
        requestAnimationFrame(() => {
            const el = textareaRef.current;
            if (!el) return;
            el.focus();
            el.selectionStart = selectionStart;
            el.selectionEnd = selectionEnd;
        });
    };

    const selectionInfo = () => {
        const el = textareaRef.current;
        if (!el) return { start: 0, end: 0 };
        return {
            start: Number.isFinite(Number(el.selectionStart)) ? el.selectionStart : 0,
            end: Number.isFinite(Number(el.selectionEnd)) ? el.selectionEnd : 0
        };
    };

    const applyWrap = (leftToken, rightToken = leftToken) => {
        const { start, end } = selectionInfo();
        const before = resolvedValue.slice(0, start);
        const middle = resolvedValue.slice(start, end);
        const after = resolvedValue.slice(end);
        const next = `${before}${leftToken}${middle}${rightToken}${after}`;
        triggerChange(next, start + leftToken.length, end + leftToken.length);
    };

    const applyLinePrefix = (type) => {
        const { start, end } = selectionInfo();
        const valueStr = resolvedValue;
        const lineStart = valueStr.lastIndexOf('\n', Math.max(0, start - 1)) + 1;
        const lineEndCandidate = valueStr.indexOf('\n', end);
        const lineEnd = lineEndCandidate === -1 ? valueStr.length : lineEndCandidate;
        const selected = valueStr.slice(lineStart, lineEnd);
        const lines = selected.split('\n');

        if (type === 'bullet') {
            const allBulleted = lines.every((l) => l.trim() === '' || l.startsWith('- '));
            const nextLines = allBulleted
                ? lines.map((l) => (l.startsWith('- ') ? l.slice(2) : l))
                : lines.map((l) => (l.trim() === '' ? l : `- ${l}`));
            const nextSelected = nextLines.join('\n');
            const nextValue = valueStr.slice(0, lineStart) + nextSelected + valueStr.slice(lineEnd);
            const delta = nextSelected.length - selected.length;
            triggerChange(nextValue, start, end + delta);
            return;
        }

        if (type === 'number') {
            const numberRegex = /^\d+\.\s/;
            const allNumbered = lines.every((l) => l.trim() === '' || numberRegex.test(l));
            const nextLines = allNumbered
                ? lines.map((l) => (numberRegex.test(l) ? l.replace(numberRegex, '') : l))
                : lines.map((l, idx) => (l.trim() === '' ? l : `${idx + 1}. ${l}`));
            const nextSelected = nextLines.join('\n');
            const nextValue = valueStr.slice(0, lineStart) + nextSelected + valueStr.slice(lineEnd);
            const delta = nextSelected.length - selected.length;
            triggerChange(nextValue, start, end + delta);
        }
    };

    const toolbarButtons = ([
        { key: 'bold', label: 'B', onClick: () => applyWrap('**') },
        { key: 'bullet', label: '•', onClick: () => applyLinePrefix('bullet') },
        { key: 'number', label: '1.', onClick: () => applyLinePrefix('number') },
    ]);

    return (
        <>
            { label && 
                <label className='text-xs text-slate-500 ' htmlFor="inv_no">{label}</label>}
            {!rich && enableToolbar && (
                <div className='flex items-center gap-2 mb-2'>
                    {toolbarButtons.map((btn) => (
                        <button
                            key={btn.key}
                            type="button"
                            onClick={btn.onClick}
                            className='h-7 min-w-7 px-2 text-xs font-bold rounded border border-slate-200 bg-white text-slate-700 hover:bg-slate-50'
                        >
                            {btn.label}
                        </button>
                    ))}
                </div>
            )}
            {rich ? (
                <MwRichEditor
                    id={id}
                    value={resolvedValue}
                    onChange={onChange}
                    placeholder={placeholder}
                    rows={rows}
                    minHeight={minHeight}
                    invalid={invalid}
                    classNameCustom={classNameCustom}
                    dir={dir}
                    textAlign={textAlign}
                />
            ) : (
                <textarea 
                    ref={textareaRef}
                    className={` text-xs text-slate-600 border w-full rounded  p-2 ${ invalid && 'border border-red-500'} ${classNameCustom}`}
                    id={id}
                    name={id} 
                    value={resolvedValue} 
                    onChange={onChange}  
                    placeholder={placeholder}
                    rows={rows} 
                    dir={dir}
                    style={{resize: 'none', direction: dir, textAlign: textAlign || (dir === 'rtl' ? 'right' : dir === 'ltr' ? 'left' : 'start')}}
                />
            )}
            { invalidMsg && <div className='text-xs text-red-500'>{invalidMsg}</div> }

        </>
    )
}

export default MwTextArea
